import { post } from "@/api/request";
const system = {
  namespaced: true,
  state: {
    cosConfig: {},
  },
  mutations: {
    SET_CONFIG: (state, cosConfig) => {
      state.cosConfig = cosConfig;
    },
  },
  actions: {
    // 获取cos凭证
    getOssToken({ commit }, randomKey) {
      return new Promise((resolve, reject) => {
        post("/engine/base/qq/tencent-cloud/credential", {
          cosKey: randomKey,
        })
          .then((res) => {
            if (res.data && res.data.success) {
              console.log("🚀 ~ getOssToken ~ res:", res);
              commit("SET_CONFIG", res.data.data);
              resolve(res.data.data);
            } else {
              reject(new Error(res.data?.msg || "获取OSS凭证失败"));
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};

export default system;
